import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAssetWorkspace, createImportSource, createImportToken } from "../../../redux/actions/jiraAssetsActions";
import { isEmptyJsonObject } from "../../../common/utils/helper";
import Spinner from "@atlaskit/spinner";
import StatusSuccessIcon from "@atlaskit/icon/core/status-success";

import { getCredentials } from "../common/util/wizard.auth";
const AssetImportSourceAndToken = () => {
  const dispatch = useDispatch();

  const workspace = useSelector((state) => state.jiraAssets.workspace);
  const token = useSelector((state) => state.jiraAssets.token);
  const importSource = useSelector((state) => state.jiraAssets.importSource);
  const selectedAssetSchema = useSelector((state) => state.jiraAssets.selectedAssetSchema);
  const importSourceName = useSelector((state) => state.jiraAssets.importSourceName);
  const creds = useSelector((state) => state.auth.creds);
  const currentData = useSelector((state) => state.wizard.currentData);

  useEffect(() => {
    let credObject = getCredentials(currentData, creds);

    //console.log("TokenSetup", workspace,importSource,token)
    //console.log(workspace === "",isEmptyJsonObject(importSource),workspace !== "" && !isEmptyJsonObject(importSource) && token === "")
    if (workspace === "") {
      //console.log("workspace")
      dispatch(getAssetWorkspace(credObject));
    } else if (workspace !== "" && isEmptyJsonObject(importSource)) {
      //console.log("importSource")
      dispatch(createImportSource(workspace, selectedAssetSchema.value, importSourceName, credObject));
    } else if (workspace !== "" && !isEmptyJsonObject(importSource) && token === "") {
      //console.log("token")
      dispatch(createImportToken(workspace, importSource.id, credObject));
    }
  }, [workspace, importSource]);

  return (
    <>
      <br></br>
      {!workspace && (
        <>
          Creating workspace
          <Spinner />
        </>
      )}
      {workspace && (
        <>
          <StatusSuccessIcon label="" color="#00875a" />
          Workspace Created
        </>
      )}
      <br></br>
      {!importSource && (
        <>
          Creating Import Source <Spinner />
        </>
      )}
      {importSource && (
        <>
          <StatusSuccessIcon label="" color="#00875a" />
          Import Source Created
        </>
      )}
      <br></br>
      {!token && (
        <>
          Creating Import Token
          <Spinner />
        </>
      )}
      {token && (
        <>
          <StatusSuccessIcon label="" color="#00875a" />
          Import Token Created
        </>
      )}
    </>
  );
};
export default AssetImportSourceAndToken;
